import { defineMessages } from '../../i18n/define';

/** Строки оболочки, которые нужны нескольким её модулям. */
export const SHELL = defineMessages({
  menuClose: { id: 'shell.menu.close', defaultMessage: 'Закрыть меню' },
  menuOpen: { id: 'shell.menu.open', defaultMessage: 'Открыть меню' },
});
